import { Cell } from '@highlight/ui'
import { Skeleton } from '@renderer/components/ui/skeleton'

interface CellListSkeletonProps {
  count?: number
  size?: 'compact' | 'default'
}

export function CellListSkeleton({ count = 6, size = 'compact' }: CellListSkeletonProps) {
  const gap = size === 'compact' ? 'gap-1.5' : 'gap-2'

  return (
    <div className={`flex flex-col ${gap}`}>
      {Array.from({ length: count }, (_, i) => (
        <Cell key={i} size={size}>
          <Cell.Header showChevron={false}>
            <Skeleton className="bg-skeleton corner-smooth size-5 rounded-md" />
            <Skeleton className="bg-skeleton h-5 w-48" />
          </Cell.Header>
        </Cell>
      ))}
    </div>
  )
}
